module.exports = __webpack_public_path__ + "static/media/VC.fb8b285f.svg";